<template>
  <div class="nav-bar">
    <router-link
      v-for="(item, index) in navItems"
      :key="index"
      :to="item.path"
      class="nav-item"
      :class="{ active: isActive(item.path) }"
      @click.native="handleTabClick(item)"
    >
      <img
        :src="isActive(item.path) ? item.activeIcon : item.icon"
        alt=""
        class="nav-icon"
      />
      <span>{{ item.name }}</span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return {
      navItems: [
        {
          name: "首页",
          path: "/",
          icon: require("@/assets/images/home.png"),
          activeIcon: require("@/assets/images/home_h.png"),
        },
        {
          name: "分类",
          path: "/category",
          icon: require("@/assets/images/category.png"),
          activeIcon: require("@/assets/images/category_h.png"),
        },
        {
          name: "我的",
          path: "/profile",
          icon: require("@/assets/images/profile.png"),
          activeIcon: require("@/assets/images/profile_h.png"),
        },
      ],
    };
  },
  methods: {
    isActive(path) {
      return this.$route.path === path;
    },

    handleTabClick(tab) {
      if (tab.name == "回顶部") {
        window.scrollTo({
          top: 0,
          behavior: "smooth", // 启用平滑滚动
        });
      }
    },

    // 监听滚动事件
    handleScrollTop() {
      if (window.scrollY > 400) {
        // 300px为临界值，可以根据需要调整
        this.navItems[0].activeIcon = require("@/assets/images/tab-top.png"); // 改成回顶部图标
        this.navItems[0].name = "回顶部";
      } else {
        this.navItems[0].activeIcon = require("@/assets/images/home_h.png"); // 改成回首页图标
        this.navItems[0].name = "首页";
      }
    },
  },

  mounted() {
    // 组件挂载后，监听滚动事件
    window.addEventListener("scroll", this.handleScrollTop);
  },
  beforeDestroy() {
    // 组件销毁时移除滚动事件监听
    window.removeEventListener("scroll", this.handleScrollTop);
  },
};
</script>

<style lang="scss" scoped>
.nav-bar {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 98px;
  background-color: #fff;
  box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-top: 1px solid #eee;
}

.nav-item {
  flex: 1;
  text-align: center;
  padding: 10px 0;
  color: #000;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;

  span {
    font-size: 20px;
  }
}

.nav-item.active {
  /* color: #42b983; */
}

.nav-icon {
  width: 46px;
  height: 42px;
  margin-bottom: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue